import Demo from 'Containers/Demo';

export default Demo;
